import type { IconData } from '@stacksjs/iconify-core'

export const realEstateBuildingFactory: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M22.86 19.81V6.09h-1.52V4.57h-4.57v1.52h-1.53v13.72h-3.05V7.62h-1.52V6.09H6.1v1.53H4.58v12.19H0V32h32V19.81ZM16.77 9.14h4.57v1.52h-4.57Zm0 3.05h4.57v7.62h-4.57ZM6.1 10.66h4.57v1.53H6.1Zm0 3.05h4.57v6.1H6.1Zm1.52 16.76H1.53v-9.14h6.09Zm22.86 0H9.15v-9.14h21.33Z\"/><path fill=\"currentColor\" d=\"M28.96 22.85h-6.1v6.1h6.1Zm-1.53 3.05h-1.52v1.53h-1.52v-3.05h3.04ZM24.39 0h1.52v1.52h-1.52Zm-1.53 1.52h1.53v1.52h-1.53ZM19.81 0h3.05v1.52h-3.05Zm1.53 22.85H10.67v6.1h10.67Zm-6.1 3.05h-1.52v1.53h-1.53v-3.05h3.05Zm4.57 0h-1.52v1.53h-1.52v-3.05h3.04ZM18.29 1.52h1.52v1.52h-1.52Zm-4.57 0h1.52v1.52h-1.52Zm-3.05 1.52h3.05v1.53h-3.05ZM9.15 1.52h1.52v1.52H9.15ZM7.62 3.04h1.53v1.53H7.62Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default realEstateBuildingFactory
